import _ from 'lodash';
import moment from 'moment';
import TimeLimitedOfferApi from '@/api/TimeLimitedOfferApi';

const state = {
  timeLimitedOffers: [],
};

const getters = {
  noTrialDiscount: state => _.find(state.timeLimitedOffers, { offerId: 'no-trial-discount' }),
  noTrialDiscountEndDate: (state, getters) => getters.noTrialDiscount && moment(getters.noTrialDiscount.endDate),
  noTrialDiscountActive: (state, getters) => {
    const endDate = getters.noTrialDiscountEndDate;
    return endDate && endDate.isAfter(moment());
  },
};

const actions = {
  async initTimeLimitedOffers({ dispatch, commit }) {
    await dispatch('fetchTimeLimitedOffers');
  },
  async deleteTimeLimitedOffer({ dispatch, commit }, offerId) {
    await TimeLimitedOfferApi.deleteTimeLimitedOffer(offerId);
    await dispatch('fetchTimeLimitedOffers');
  },
  async fetchTimeLimitedOffers({ commit }) {
    const timeLimitedOffers = await TimeLimitedOfferApi.getTimeLimitedOffers();
    commit('setTimeLimitedOffers', timeLimitedOffers);
  },
};

const mutations = {
  setTimeLimitedOffers(state, timeLimitedOffers) {
    state.timeLimitedOffers = timeLimitedOffers;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
